import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';

//import injectTapEventPlugin from 'react-tap-event-plugin';

// Redux Setup
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';

import { ConnectedRouter, routerMiddleware } from 'react-router-redux';

import logger from 'redux-logger';

// Mixpanel
import mixpanel from 'mixpanel-browser';
import MixpanelProvider from 'react-mixpanel';

import rootReducer from './rootReducer.js';

// Common Styles etc.
import './shared/styles/index.scss';

// React Routing
import {
	HashRouter as Router,
	Route,
	Redirect,
} from 'react-router-dom'

// Custom classes
import Header from './shared/components/Header';
import ErrorContainer from './errors/ErrorContainer';

// Saga
import rootSaga from './rootSaga.js';

// Common Components
import Page from './shared/components/Page';

// Auth routes
import SignInContainer from './auth/SignIn';

// Apps Routes
import AppCreate from './apps/pages/AppCreate';
import AppContent, { AppUnselected } from './apps/pages/AppContent';

// Organizations Routes
import OrganizationsSidebar from './organizations/components/OrganizationsSidebar';
import {  OrganizationsCreateContainer } from './organizations/components/OrganizationCreate';

import OrganizationSidebar from './organizations/components/OrganizationSidebar';
import OrganizationMap from './organizations/components/OrganizationMap';

import OrganizationPOIUpload from './organizations/components/OrganizationPOIUpload';
import POIUploadStatus from './organizations/components/POIUploadStatus';

// Validation Routes
import ValidationPOIOrganization from './validation/components/ValidationPOIOrganization';
import ValidationFixPOICenter from './validation/components/ValidationFixPOICenter';
import ValidationFixOnPremise from './validation/components/ValidationFixOnPremise';
import ValidationInstructionsSidebar from './validation/components/ValidationInstructionsSidebar';
import NextJob from './validation/components/NextJob';

// Admin Routes
import JobsList from './admin/pages/JobsSummary';
import UserAccounts from './admin/pages/UserAccounts';
import CreateAccount from './admin/pages/CreateAccount';
import ValidationStatistics from './admin/pages/ValidationStatistics';

// Actions
import { SAGA_COMMON_LOAD_ORGANIZATIONS, SAGA_COMMON_LOAD_CATEGORIES } from './shared/actions';

import createHistory from 'history/createHashHistory'

const history = createHistory();

/********************************/
/***** THIRD PARTY HELPERS *****/
/*******************************/

// Redux observer middlewear
//const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Redux and saga setup
const sagaMiddleware = createSagaMiddleware()
let store = createStore(rootReducer, applyMiddleware(logger, sagaMiddleware,routerMiddleware(history)));
sagaMiddleware.run(rootSaga);

mixpanel.init('3fddc9b93861f9388569906974d121ce');

let isAdmin = false;

const initActions = () => {
	const token = localStorage.getItem('token');
	const admin = localStorage.getItem('admin');

	if (!_.isUndefined(admin) && !_.isNull(admin)) {
		isAdmin = admin === 'false' ? false : true;
		if (!isAdmin) {
			history.push('/loadNextJob');
		}
	}

	if (_.isUndefined(token) || _.isNull(token)) {
		history.push('/auth/signin');
		return;
    }
}

initActions();

const mainInitActions = () => {
	// Load all organizations
	store.dispatch({
		type: SAGA_COMMON_LOAD_ORGANIZATIONS,
	});
	// Load all categories
	store.dispatch({
		type: SAGA_COMMON_LOAD_CATEGORIES,
	});
}


/*******************************/
/***** REACT ROUTER SETUP *****/
/******************************/

const AuthRoutes = () => {
	return (
		<div id="content-area">
			{ErrorArea()}
			<div className="signin-container">
				<SignInContainer />
			</div>
		</div>
	)
};

const ErrorArea = () => {
	return (
		<div id="error-area">
			<ErrorContainer />
		</div>
	)
}

const MainRoutes = () => {
	return (
		<div>
			<Router>
				<Header admin={isAdmin} />
			</Router>
			{ErrorArea()}
			<Router>
				<div id="content-area">
					{/* Admin routes */}
					<Route exact path="/admin/jobs" component={JobsList} />
					<Route exact path="/admin/accounts" component={UserAccounts} />
					<Route exact path="/admin/accounts/create" component={CreateAccount} />

					<Route exact path="/admin/validation/statistics" component={ValidationStatistics} />

					{/* Apps */}
					<Route exact path="/createApp" component={AppCreate} />
					<Route exact path="/apps" component={AppUnselected} />
					<Route exact path="/apps/:app_id" component={AppContent} />

					{/* Organizations */}
					<Route exact path="/organizations" render={(props) => (
						<Page>
							<Page.Sidebar>
								<OrganizationsSidebar {...props} />
							</Page.Sidebar>
						</Page>
					)} />
					<Route exact path="/createOrganization" render={(props) => (
						<Page>
							<Page.MainArea>
								<OrganizationsCreateContainer {...props} />
							</Page.MainArea>
						</Page>
					)}/>
					<Route path="/organizations/:organization_id/pois" render={(props) => (
						<Page>
							<Page.Sidebar>
								<OrganizationSidebar {...props} />
							</Page.Sidebar>
							<Page.MainArea>
								<OrganizationMap {...props} />
							</Page.MainArea>
						</Page>
					)} />
					<Route path="/organizations/:organization_id/upload" render={(props) => (
						<Page>
							<Page.MainArea>
								<OrganizationPOIUpload {...props} />
							</Page.MainArea>
						</Page>
					)} />
					<Route path="/organizations/:organization_id/create-poi" render={(props) => (
						<Page>
							<Page.MainArea>
								<OrganizationPOIUpload {...props} />
							</Page.MainArea>
						</Page>
					)} />

					<Route path="/organizations/uploadStatus" exact render={(props) => (
						<Page>
							<Page.MainArea>
								<POIUploadStatus {...props} />
							</Page.MainArea>
						</Page>
					)} />

					{/* Validation stages */}
					<Route exact path="/loadNextJob" render={() => (
						<Page>
							<Page.MainArea>
								<NextJob />
							</Page.MainArea>
						</Page>
					)} />
					<Route exact path="/validation/validOrganization/:poi_id" render={(props) => (
						<Page>
							<Page.Sidebar>
								<ValidationInstructionsSidebar validationStage="validOrganization" {...props}/>
							</Page.Sidebar>
							<Page.MainArea>
								<ValidationPOIOrganization {...props} />
							</Page.MainArea>
						</Page>
					)} />
					<Route exact path="/validation/fixPOICenter/:poi_id" render={(props) => (
						<Page>
							<Page.Sidebar>
								<ValidationInstructionsSidebar validationStage="fixPOICenter" {...props}/>
							</Page.Sidebar>
							<Page.MainArea>
								<ValidationFixPOICenter {...props} />
							</Page.MainArea>
						</Page>
					)} />
					<Route exact path="/validation/fixOnPremise/:poi_id" render={(props) => (
						<Page>
							<Page.Sidebar>
								<ValidationInstructionsSidebar validationStage="fixOnPremise" {...props}/>
							</Page.Sidebar>
							<Page.MainArea>
								<ValidationFixOnPremise {...props} />
							</Page.MainArea>
						</Page>
					)} />
				</div>
			</Router>
		</div>
	)
};

const AppSetup = () => (
	<Provider store={store}>
		<MixpanelProvider mixpanel={mixpanel}>
			<ConnectedRouter history={history}>
				<div className="container">
					<Route path="/" exact render={()=>(
						<Redirect to="/apps" />
					)} />
					<Route render={((obj) => {
						const token = localStorage.getItem('token');
						if (obj.location.pathname === '/auth/signin') {
							if (!_.isUndefined(token) && !_.isNull(token)) {
								history.push('/apps');
								return;
							}
							return AuthRoutes();
						}
						if (obj.location.pathname === '/auth/signout') {
							localStorage.removeItem('token');
							history.push('/auth/signin');
							return null;
						}
						if (_.isUndefined(token) || _.isNull(token)) {
							history.push('/auth/signin');
							return null;
						}
						mainInitActions();
						return MainRoutes();
					})} />
				</div>
			</ConnectedRouter>
		</MixpanelProvider>
	</Provider>
)

ReactDOM.render(<AppSetup />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js